// extracted by mini-css-extract-plugin
export default {"modify":"AddOrRemoveLearnersActions_modify__VRG07","selected":"AddOrRemoveLearnersActions_selected__X3nxk"};